// extracted by mini-css-extract-plugin
export default {"section":"NotFound_section__p7fyD","code":"NotFound_code__n3FlE"};